import {Component, OnInit} from '@angular/core';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ErrorSuccessMsgComponent} from '../../../../../modals/error-success-msg/error-success-msg.component';

@Component({
  selector: 'app-members-profile-changes',
  templateUrl: './members-profile-changes.component.html',
  styleUrls: ['./members-profile-changes.component.scss']
})
export class MembersProfileChangesComponent implements OnInit {

  memberId: number | string;
  memberInfo: any;
  getProfileChangesList: any;
  totalCount: number;
  page = 0;
  size = 10;
  statusModal: BsModalRef;

  constructor(
    private hcaMemberService: HcaMemberService,
    private modalService: BsModalService,
  ) {
  }

  getProfileChangesData(pageNo?) {
    this.page = pageNo ? pageNo : this.page;
    this.hcaMemberService.getProfileChanges(this.memberId, this.page > 0 ? this.page - 1 : this.page).subscribe((res: any) => {
      if (res.error === 0) {
        this.getProfileChangesList = res.responseObj.results;
        console.log(this.getProfileChangesList);
        this.totalCount = res.responseObj && res.responseObj.totalRecords ? res.responseObj.totalRecords : 0;
      } else {
        this.getProfileChangesList = [];
        this.totalCount = 0;
      }
    }, err => {
      this.getProfileChangesList = [];
      this.totalCount = 0;
      console.error('Error while updating member issue status by Id: ', err.message);
    });
  }

  ngOnInit() {
    this.memberId = this.hcaMemberService.getMemberId;
    this.memberInfo = this.hcaMemberService.getMemberInfo;
    this.getProfileChangesData(this.page);
  }

  // open sucess or error message display modal
  openSuccessErrorMsg(mode, msg) {
    this.statusModal = this.modalService.show(ErrorSuccessMsgComponent, {class: 'errorSuccess-modal'});
    let message = '';
    let action1 = '';
    let style = '';
    if (mode === 'Success') {
      message = msg;
      action1 = '';
      style = 'activate';
    } else if (mode === 'Error') {
      message = msg;
      action1 = '';
      style = 'deactivate';
    }
    this.statusModal.content.srcObject = {
      mode: 'duplicateMsg',
      type: 'member-list',
      message: message,
      action1: action1,
      action2: 'OK',
      action: '',
      style: style
    };
  }

  resendVerification(id, email) {
    this.hcaMemberService.sendVerificationEmail(id, email).subscribe((res: any) => {
      if (res.error === 0) {
        this.openSuccessErrorMsg('Success', res && res.message ? res.message : 'Success');
      } else {
        this.openSuccessErrorMsg('Error', res && res.message ? res.message : 'Error while sending the verification mail.');
      }
    }, err => {
      this.openSuccessErrorMsg('Error', err && err.message ? err.message : 'Error while sending the verification mail.');
      console.error('Error while updating member issue status by Id: ', err.message);
    });
  }

  allowAccountsMerge(updatedEmailId) {
    this.hcaMemberService.allowAccountsMerge(updatedEmailId).subscribe((res: any) => {
      if (res.error === 0) {
        this.openSuccessErrorMsg('Success', res && res.message ? res.message : 'Success');
      } else {
        this.openSuccessErrorMsg('Error', res && res.message ? res.message : 'Error while merging email.');
      }
    }, err => {
      this.openSuccessErrorMsg('Error', err && err.message ? err.message : 'Error while merging email.');
      console.error('Error while merging email by Id: ', err.message);
    });
  }

  rejectAccountsMerge(updatedEmailId) {
    this.hcaMemberService.rejectAccountsMerge(updatedEmailId).subscribe((res: any) => {
      if (res.error === 0) {
        this.openSuccessErrorMsg('Success', res && res.message ? res.message : 'Success');
      } else {
        this.openSuccessErrorMsg('Error', res && res.message ? res.message : 'Error while reject merging  email.');
      }
    }, err => {
      this.openSuccessErrorMsg('Error', err && err.message ? err.message : 'Error while reject merging email.');
      console.error('Error while reject merging email by Id: ', err.message);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reception/members-management/members-profile-changes/members-profile-changes.component.ts